module.exports = __webpack_public_path__ + "static/media/footer-2-2.93a9c842.png";